import { Form, Select, Radio, message, Col, Row, Upload, Input, Typography, Modal, Button } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import http from "../../../services/http";
import { createUUID } from "../../../helpers/generateUid";
const { TextArea } = Input;
const { Text } = Typography;

const options_tipo = [
  { value: 1, label: "Colaborador" },
  { value: 2, label: "Filial / Setor" },
];

const rulesValidation = {
  tipo: [{ required: true, message: "Selecione o destino!" }],
  id_colaborador: [{ required: true, message: "Selecione o colaborador!" }],
  id_cad_setores: [{ required: true, message: "Selecione a filial/setor!" }],
  id_grupo_avaliadores: [{ required: true, message: "Selecione o avaliador!" }],
  oque: [{ required: true, message: "Descreva o apontamento!" }],
};

const formFile = (e) => {
  const size = e?.file?.size / 1024 / 1024 > 25;
  if (size) {
    message.error("Tamanho não suportado, máximo 25MB!");
    return null;
  }
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const ProblemasTableForm = ({ open, id, onFinish, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [setores, setSetores] = useState([]);
  const [avaliadores, setAvaliadores] = useState([]);
  const [sistemas, setSistemas] = useState([]);
  const tipo = Form.useWatch("tipo", form);
  const files = Form.useWatch("files", form);

  useEffect(() => {
    if (open && id > 0) {
      carregarProblema(id);
    }
  }, [open]);

  useEffect(() => {
    listarSetores();
    listarColaboradores();
    listarGruposAvaliadores();
    listarSistemas();
  }, []);

  const listarSetores = async (pesquisa = "") => {
    const api = await http("get", `v1/problemas/listar_setores?pesquisa=${pesquisa}`, []);
    if (api?.statusCode === 200) {
      const response = api?.response?.data ?? [];
      let array_options = [];
      for (const el of response) {
        array_options.push({ value: el.id, label: el.setor });
      }
      setSetores(array_options);
    } else {
      message.error(api.response.message);
    }
  };

  const listarColaboradores = async (pesquisa = "") => {
    const api = await http("get", `v1/problemas/listar_colaboradores?pesquisa=${pesquisa}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      let array_options = [];
      for (const el of response) {
        array_options.push({ value: el.id, label: `${el.matricula} - ${el.nome}` });
      }
      setColaboradores(array_options);
    } else {
      message.error(api.response.message);
    }
  };

  const listarGruposAvaliadores = async () => {
    const api = await http("get", `v1/problemas_grupo_avaliadores/listar_ativos`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      let array_options = [{ value: 0, label: "Sem avaliadores" }];
      for (const el of response) {
        array_options.push({
          value: el.id,
          label: el.descricao,
        });
      }
      setAvaliadores(array_options);
    } else {
      message.error(api.response.message);
    }
  };

  const listarSistemas = async () => {
    const api = await http("get", `v1/problemas_sistemas_origens/listar_disponiveis_lancamento`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      let array_options = [{ label: "Sem grupo", value: 0 }];
      for (const el of response) {
        array_options.push({ value: el.id, label: el.descricao });
      }
      setSistemas(array_options);
    } else {
      message.error(api.response.message);
    }
  };

  const carregarProblema = async (id) => {
    setLoading(true);

    const api = await http("get", `v1/problemas/carregar/${id}`, []);

    if (api.statusCode === 200) {
      const response = api?.response?.data;
      const tipo_responsavel = response?.id_colaborador ? 1 : 2;

      form.resetFields();

      if (response?.id_colaborador > 0) {
        setColaboradores([{ label: response?.colaborador, value: response?.id_colaborador }]);
      }
      if (response?.id_cad_setores > 0) {
        setSetores([{ label: response?.setor, value: response?.id_cad_setores }]);
      }

      if (response?.id_sistemas_origens > 0) {
        const filtro = sistemas?.filter((e) => e.value === response?.id_sistemas_origens);
        if (filtro?.length === 0) {
          setSistemas((e) => [...e, ...[{ label: response?.sistema, value: response?.id_sistemas_origens }]]);
        }
      }

      form.setFieldsValue({
        id_colaborador: response?.id_colaborador ?? null,
        id_cad_setores: response?.id_cad_setores ?? null,
        id_grupo_avaliadores: response?.id_grupo_avaliadores ?? 0,
        id_sistemas_origens: response?.id_sistemas_origens ?? 0,
        porque: response?.porque,
        oque: response?.oque,
        tipo: tipo_responsavel,
      });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const cadastrarProblema = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas/adicionar`, formulario, "multipart/form-data");
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      form.resetFields();
      onFinish();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const alterarProblema = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas/alterar`, formulario, "multipart/form-data");
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      form.resetFields();
      onFinish();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const handleClose = useCallback(() => {
    form.resetFields();
    onClose();
  }, []);

  const onSubmit = (formulario) => {
    const formData = new FormData();

    formData.append("id_sistemas_origens", formulario.id_sistemas_origens > 0 ? formulario.id_sistemas_origens : 1);
    formData.append("tipo", formulario?.tipo ?? "");
    formData.append("id_colaborador", formulario?.id_colaborador ?? "");
    formData.append("id_cad_setores", formulario?.id_cad_setores ?? "");
    formData.append("id_sistemas_origens", formulario?.id_sistemas_origens ?? "");
    formData.append("id_grupo_avaliadores", formulario?.id_grupo_avaliadores ?? "");
    formData.append("oque", formulario?.oque ?? "");
    formData.append("porque", formulario?.porque ?? "");
    for (const f of formulario?.files ?? []) {
      formData.append("files[]", f?.originFileObj ?? "");
    }

    if (id > 0) {
      formData.append("id", id ?? 0);
      alterarProblema(formData);
    } else {
      cadastrarProblema(formData);
    }
  };

  const handlePaste = useCallback((e) => {
    setLoading(true);
    if (e?.clipboardData?.files?.length) {
      if (files?.length >= 5) {
        setLoading(false);
        return;
      }

      const file = e?.clipboardData?.files[0];

      const arquivo = {
        uid: createUUID(),
        originFileObj: file,
        name: file?.name,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        type: file?.type,
        size: file?.size,
      };

      form?.setFieldsValue({ files: [...(files ?? []), arquivo] });
    } else {
      message.error("Nenhum arquivo selecionado!");
    }
    setLoading(false);
  }, []);

  return (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {id > 0 ? "Editar" : "Adicionar"} Plano de Ação
        </Text>
      }
      open={open}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={handleClose}>
      <Form onPaste={handlePaste} form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="tipo" label="Destino" rules={rulesValidation.tipo} initialValue={tipo}>
              <Radio.Group options={options_tipo} size="large" optionType="button" buttonStyle="solid" />
            </Form.Item>
          </Col>

          {tipo === 1 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_colaborador" label="Colaborador" rules={rulesValidation.id_colaborador}>
                <Select
                  showSearch
                  size="large"
                  placeholder="Selecione o colaborador"
                  disabled={loading}
                  options={colaboradores}
                  onSearch={(e) => listarColaboradores(e)}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}
          {tipo === 2 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="id_cad_setores" label="Filial/Setor" rules={rulesValidation.id_cad_setores}>
                <Select
                  showSearch
                  size="large"
                  placeholder="Selecione a filial/setor"
                  disabled={loading}
                  options={setores}
                  onSearch={(e) => listarSetores(e)}
                  filterOption={false}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="id_sistemas_origens"
              label={
                <Text>
                  Grupo Origem <Text type="secondary">(Opcional)</Text>
                </Text>
              }>
              <Select size="large" placeholder="Selecione o grupo" disabled={loading} options={sistemas} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="id_grupo_avaliadores"
              label="Grupo/Usuário Avaliador"
              rules={rulesValidation.id_grupo_avaliadores}>
              <Select
                size="large"
                showSearch
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                placeholder="Selecione o avaliador"
                disabled={loading}
                options={avaliadores}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="oque" label="Apontamento (O que?)" rules={rulesValidation.oque}>
              <TextArea
                size="large"
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder="Informe o apontamento"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="porque" label="Motivo (Por quê?)">
              <TextArea
                size="large"
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder="Informe o motivo"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          {!(id > 0) && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                getValueFromEvent={formFile}
                name="files"
                valuePropName="fileList"
                label={
                  <Text>
                    Anexos (Opcional) <Text type="secondary">Máx: 5</Text>
                  </Text>
                }>
                <Upload disabled={loading} multiple beforeUpload={() => false} maxCount={5}>
                  <Button loading={loading} size="large" icon={<UploadOutlined />}>
                    Click para enviar
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export { ProblemasTableForm };
